/*
 * � 2020 Microsoft. All rights reserved.
 */

define('MenuUI/StatsOverviewTile',['pixi', 'absolute', 'absolute/stringmanager', 'lodash', 'Solitaire/SolitaireGameMode', 'MenuUI/MenuTile',
    'MenuUI/Label', 'MenuUI/ColorConstants', 'MenuUI/MsftIconButton'],

    function (PIXI, Absolute, _s, _, SolitaireGameMode, MenuTile, Label, ColorConstants, MsftIconButton) {

        var StatsOverviewTile = function (config, statsModel, menu) {
            var defaultConfig = {
                letterStyle: {
                    font: Absolute.ScreenMetrics.getResScale() * 37 + 'px Arial',
                    fontFamily: 'segoe',
                    fill: '#ffffff',
                    tint: 0xffffff,
                    align: 'left'
                },

                borderSize: 0,
                borderColor: 0xffffff,
                backgroundColor: 0x000000,

                width: 400,
                height: 380,

                padding: 15,

                lineWidth: 3,

                titleFontSize: 30,
                titleHorizontalPadding: 0,

                generalFontSize: 26,
                generalFontMargin: 5,

                buttonWidth: 160,
                buttonPadding: 10
            };
            this.initStatsOverviewTile(_.extend(defaultConfig, config), statsModel, menu);
        };

        StatsOverviewTile.prototype = Object.create(MenuTile.prototype);

        StatsOverviewTile.prototype.initStatsOverviewTile = function (config, statsModel, menu) {

            this.config = config;
            this.menu = menu;
            this.statsModel = statsModel;

            this.hasMoreInfo = this.statsModel.gameMode != SolitaireGameMode.DailyChallenge &&
                this.statsModel.gameMode != SolitaireGameMode.StarClub && !this.statsModel.isDetailedStats
                && this.statsModel.gameMode != SolitaireGameMode.FreeCell;

            var backgroundImage = new PIXI.Graphics();
            backgroundImage.beginFill(ColorConstants[SolitaireGameMode.getModeById(statsModel.gameMode)]);
            backgroundImage.drawRect(0, 0,
                Absolute.Coords.x(this.config.width),
                Absolute.Coords.y(this.config.height));
            backgroundImage.endFill();

            config.image = backgroundImage;
            config.icon = this.getIcon(SolitaireGameMode.getModeById(statsModel.gameMode));
            config.label = SolitaireGameMode.getModeById(statsModel.gameMode);

            MenuTile.call(this, config);

            if (Absolute.Platform.isMobile()) {
                this.config.generalFontSize += 2;
                this.config.generalFontMargin *= 1 // Workaround for poor ScreenMetrics scaling.
            }

            this.gameModeFontStyle = {
                font: 'Bold ' + Absolute.ScreenMetrics.getResScale() * this.config.generalFontSize + 'px Arial',
                fontFamily: 'segoe',
                fill: '#ffffff',
                tint: 0xffffff,
                align: 'left'
            };

            this.icon.anchor.set(0, 0.5);
            this.label.anchor.set(0, 0.4);
            this.icon.x = Absolute.Coords.x(this.config.padding + this.config.titleHorizontalPadding);
            this.label.x = this.icon.x + this.icon.width + Absolute.Coords.x(this.config.titleHorizontalPadding);
            this.icon.y = this.label.y = Absolute.Coords.y(this.config.padding + (this.icon.height / 2));

            var horizontalLine = new PIXI.Graphics();
            var horizontalLineLength = Absolute.Coords.x(this.config.width - (2 * this.config.padding));

            horizontalLine.moveTo(0, 0);
            horizontalLine.lineStyle(Absolute.Coords.x(this.config.lineWidth), 0xffffff, 1);
            horizontalLine.lineTo(horizontalLineLength, 0);
            horizontalLine.x = (this.width - horizontalLineLength) / 2;
            horizontalLine.y = Absolute.Coords.y(this.config.padding + this.icon.height + this.config.padding);
            this.addChild(horizontalLine);

            if (statsModel.StatKey) {

                var secondLabel = new PIXI.Text(_s("stats.mode." + statsModel.StatKey.Key), this.gameModeFontStyle);
                secondLabel.position.set(
                    Absolute.Coords.x(this.config.width - this.config.padding),
                    this.icon.y);
                secondLabel.anchor.set(1, 0.4);
                Absolute.StringManager.shrinkToFit(secondLabel, this.config.generalFontSize, '', Absolute.Coords.x(this.config.width * 0.4));

                this.addChild(secondLabel);
            }

            this.statsList = new PIXI.DisplayObjectContainer();
            this.statsList.x = 0;
            this.statsList.y = horizontalLine.y + Absolute.Coords.y(this.config.padding);

            if (this.hasMoreInfo) {
                var buttonWidth = Absolute.Coords.x(this.config.buttonWidth + 2 * this.config.buttonPadding);
                var buttonHeight = Absolute.Coords.y(this.config.generalFontSize + (2 * this.config.buttonPadding));

                var buttonFontStyle = {
                    font: Absolute.ScreenMetrics.getResScale() * this.config.generalFontSize + 'px Arial',
                    fontFamily: 'segoeLight',
                    fill: '#ffffff',
                    tint: 0xffffff,
                    align: 'left'
                };

                var seeMoreButton = new PIXI.DisplayObjectContainer();
                seeMoreButton.position.set(
                    Absolute.Coords.x(this.config.width - this.config.padding) - buttonWidth,
                    Absolute.Coords.y(this.config.height - this.config.padding) - buttonHeight);

                var seeMoreLabel = new PIXI.Text(_s('buttons.seeMore'), buttonFontStyle);
                seeMoreLabel.position.set(
                    buttonWidth / 2,
                    buttonHeight / 2);
                seeMoreLabel.anchor.set(0.5, 0.4);
                Absolute.StringManager.shrinkToFit(seeMoreLabel, this.config.generalFontSize, '', buttonWidth - Absolute.Coords.x(2 * this.config.padding));
                seeMoreButton.addChild(seeMoreLabel);

                var seeMoreGraphics = new PIXI.Graphics();
                seeMoreGraphics.beginFill(0xFFFFFF, 0);
                seeMoreGraphics.lineStyle(Absolute.Coords.x(this.config.lineWidth), 0xFFFFFF);
                seeMoreGraphics.drawRect(0, 0, buttonWidth, buttonHeight);

                seeMoreButton.addChild(seeMoreGraphics);
                this.addChild(seeMoreButton);
            }
        };

        StatsOverviewTile.prototype.getIcon = function (modeName) {
            return "mainmenu/icon_stats_" + modeName.toLowerCase() + ".png";
        };

        StatsOverviewTile.prototype.showStats = function () {

            while (this.statsList.children.length > 0) {
                this.statsList.removeChildAt(0);
            }

            var yOffset = 0, leftAlign = Absolute.Coords.x(this.config.padding), rightAlign = Absolute.Coords.x(this.config.width - this.config.padding);


            _.forEach(this.statsModel.getStats(), function (statsItem) {
                var titleFontStyle = {
                    font: Absolute.ScreenMetrics.getResScale() * this.config.generalFontSize + 'px Arial',
                    fontFamily: 'segoeLight',
                    fill: '#ffffff',
                    tint: 0xffffff,
                    align: 'left'
                };
                var valueFontStyle = { // Shrink to fit changes this variable so I need 2 or the valueText will inherit the titleText shrink...
                    font: Absolute.ScreenMetrics.getResScale() * this.config.generalFontSize + 'px Arial',
                    fontFamily: 'segoeLight',
                    fill: '#ffffff',
                    tint: 0xffffff,
                    align: 'left'
                };
                var title = new PIXI.Text(_s("stats.item." + statsItem.stringKey), titleFontStyle);
                title.position.set(leftAlign, Absolute.Coords.y(yOffset));
                Absolute.StringManager.shrinkToFit(title, this.config.generalFontSize, '',
                    Absolute.Coords.x(this.config.width - (2 * this.config.padding) * 0.7));

                var valueText = new PIXI.Text(statsItem.value, valueFontStyle);
                valueText.anchor.set(1, 0);
                valueText.position.set(rightAlign, Absolute.Coords.y(yOffset));
                Absolute.StringManager.shrinkToFit(valueText, this.config.generalFontSize, '',
                    Absolute.Coords.x(this.config.width - (2 * this.config.padding) * 0.3));

                this.statsList.addChild(title);
                this.statsList.addChild(valueText);

                yOffset += Absolute.Coords.y(this.config.generalFontSize + this.config.generalFontMargin);
            }, this);

            this.addChild(this.statsList);
        };

        StatsOverviewTile.prototype.handleClick = function () {
            this.menu.handleStatsTileClick(this.statsModel.gameMode);
        };

        StatsOverviewTile.prototype.onShow = function () {
            this.statsModel.updateStats();
            this.showStats();
            this.interactive = this.hasMoreInfo;
        };

        return StatsOverviewTile;

    });

